import { render } from "./PreviewImage.vue?vue&type=template&id=1945f17a"
import script from "./PreviewImage.vue?vue&type=script&lang=js"
export * from "./PreviewImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__